const SESSION_REF_KEY = 'rhythme_event_ref';

/**
 * Refresh resume pointer: event id only.
 * Playback is never stored in localStorage.
 */
export function saveSessionEventId(eventId) {
  if (!eventId || typeof eventId !== 'string') return;
  localStorage.setItem(SESSION_REF_KEY, JSON.stringify({ eventId }));
}

export function loadSessionEventId() {
  try {
    const raw = localStorage.getItem(SESSION_REF_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return typeof parsed?.eventId === 'string' && parsed.eventId ? parsed.eventId : null;
  } catch {
    return null;
  }
}

export function clearSessionEventId() {
  localStorage.removeItem(SESSION_REF_KEY);
}
